import { render } from "./BillingBoard.vue?vue&type=template&id=5f43d12c"
import script from "./BillingBoard.vue?vue&type=script&lang=js"
export * from "./BillingBoard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__